import 'Styles/header_overflow.scss'

import React from 'react';
import { connect } from 'react-redux';
import { push, goBack } from 'react-router-redux';

import decode from 'Utils/entities';
import { parsePath, pathToSettings } from 'Utils/nav/NavHelpers';

import { trackGAEvent, isLoggedIn } from 'Actions/adsActions';
import {
	resetOverlay, showConfirmModal, showLoginModal,
	showShareModal,
	displayNotification
} from 'Actions/UiActions';
import { updateFollowing } from 'Actions/ForumviewActions';
import { markAsReadPM, movePMs } from 'Actions/MessagesviewActions';
import { markAsRead } from 'Actions/ThreadviewActions';
import { refreshWidget } from 'Actions/WidgetActions';

import {
	canDeleteThread, currentUser, getUserInfo,
	isSubscribedForum, isSubscribedThread, selectedItemsUnread,
	canOpenCloseThread,
	getPmFolders, currentPMFolder
} from 'Actions/ContextInfoActions';
import { refreshPage } from 'Actions/GlobalMetaActions';
import { deleteRestoreThread, liftUserBan, banUser_confirm } from 'Actions/ModToolsActions';
import BanUserConfirmation from 'Components/modtools/banUserConfirmation';

import headerSelector from 'Selectors/headerSelector';

class HeaderOverflow extends React.Component {
	constructor( props ) {
		super( props );
		this.currentPath = [];
	}

	componentDidMount() {
		this.currentPath = parsePath( this.props.routing.locationBeforeTransitions.pathname );
	}

	componentWillUpdate( nextProps ) {
		if(
			this.props.routing.locationBeforeTransitions.pathname !== nextProps.routing.locationBeforeTransitions.pathname
		) {
			this.currentPath = parsePath( nextProps.routing.locationBeforeTransitions.pathname );
		}
	}

	login() {
		this.props.dispatch(resetOverlay());
		this.props.dispatch(showLoginModal());
		// Record the Google Analytics event.
		this.props.dispatch( trackGAEvent( false, 'login', 'uiAction', 'overflow') );
	}

	refresh() {
		this.props.dispatch( refreshPage( true ) );
		// Record the Google Analytics event.
		this.props.dispatch( trackGAEvent( false, 'refresh', 'uiAction', 'overflow') );
	}

	refreshWidgets() {
		// Refresh all widgets
		this.props.dispatch( refreshWidget() );
		this.props.dispatch( resetOverlay() );

		// Record the Google Analytics event.
		this.props.dispatch( trackGAEvent( false, 'refresh_AllWidgets', 'uiAction', 'overflow') );
	}

	settings() {
		this.props.dispatch( push( pathToSettings() ) );
		// Record the Google Analytics event.
		this.props.dispatch( trackGAEvent( false, 'settings', 'uiAction', 'overflow') );
	}

	goBack() {
		this.props.dispatch( goBack() );
	}

	callMarkAsRead = () => {
		switch( this.currentPath[ 1 ] || this.currentPath[ 0 ] ) {
			case '/':
			case 'forums':
				let id =  this.currentPath[ 2 ] || '-1';
				this.props.dispatch( markAsRead( id, 'forums' ) );
				break;

			case 'following':
			case 'participated':
			case 'latest':
			case 'updated':
				let items = this.props.dispatch( selectedItemsUnread() );
				if( items && items.unreadItems.length ) {
					this.props.dispatch( markAsRead( items.unreadItems, items.entity ) );
				}
				this.props.dispatch( resetOverlay() );
				break;

			case 'pms':
				this.props.dispatch( resetOverlay() );
				this.props.dispatch( markAsReadPM( this.currentPath[ 2 ], true, true ) );
				break;
		}
		// Record the Google Analytics event.
		this.props.dispatch( trackGAEvent( false, `markAsRead_${ this.currentPath[ 1 ] || 'index' }`, 'uiAction', 'overflow') );
	};

	deleteThread( deleteThread ) {
		this.props.dispatch( resetOverlay() );
		let title = `${ deleteThread ? 'Restore' : 'Delete' } Topic`,
			question = `Would you like to ${ deleteThread ? 'restore' : 'delete' } this topic?`,
			threadid = this.currentPath[ 2 ];

		this.props.dispatch( showConfirmModal( title, question, () => this.props.dispatch( deleteRestoreThread( threadid, deleteThread ) ) ) );

		// Record the Google Analytics event.
		this.props.dispatch( trackGAEvent( false, 'deleteRestoreThread', 'uiAction', 'overflow', ( deleteThread ? 1 : 0 )) );
	}

	subscribeTo( isSub = 0 ) {
		let subType = '', data = {};
		switch( this.currentPath[1] ) {
			case 'forums':
				subType = 'Forum';
				data = {
					forum: {
						id: parseInt( this.currentPath[ 2 ] ),
						isSubscribed: isSub
					}
				};
				break;

			case 'topics':
				subType = 'Topic';
				data = {
					thread: {
						id: parseInt( this.currentPath[ 2 ] ),
						isSubscribed: isSub
					}
				};
				break;
		}

		data.ustate = this.props.dispatch( currentUser() );

		this.props.dispatch(resetOverlay());

		if( isSub === 1  ) {
			this.props.dispatch( showConfirmModal( 'Unsubscribe', `Would you like to unsubscribe from this ${subType}?`, () => this.props.dispatch( updateFollowing( data ) ) ) );
		} else {
			this.props.dispatch( updateFollowing( data ) );
		}

		// Record the Google Analytics event.
		this.props.dispatch( trackGAEvent( false, `subscribe_${ subType }`, 'uiAction', 'overflow' ) );
	}

	banUser( user_info, banType ) {
		this.props.dispatch( resetOverlay() );
		if( banType === 'unban' ) {
			let title = `Lift Ban`,
				question = <p>Are you sure you want to lift the ban on <strong>{ user_info.userName }</strong>?</p>;
			this.props.dispatch( showConfirmModal( title, question, () => this.props.dispatch( liftUserBan( user_info.id ) ) ) );

		} else {
			this.props.dispatch( banUser_confirm( user_info.id, banType, ( type, content ) => <BanUserConfirmation type={ type } content={ content } /> ) );
		}

		// Record the Google Analytics event.
		this.props.dispatch( trackGAEvent( false, `banUser_${ banType ? banType : 'simple' }`, 'uiAction', 'overflow' ) );
		this.props.dispatch( trackGAEvent( false, `modBanUserConfirmation_${ banType ? banType : 'simple' }`, 'moderatorAction', 'banUser' ) );
	}

	shareLink() {
		this.props.dispatch( showShareModal() );
	}

	moveSelectedPms = () => {
		let selectedPMs = [ this.currentPath[ 2 ] ],
			messageFolder = this.props.dispatch( currentPMFolder( parseInt( this.currentPath[ 2 ] ) ) ),
			folderList = this.props.dispatch( getPmFolders() ),
			otherFolders = Object.keys( folderList ).filter( ( f ) => folderList[ f ].movableitems && parseInt( f ) !== parseInt( messageFolder.id ) ),
			folderSelect = [];

		if( folderList[ messageFolder.id ].movableitems !== true ) {
			displayNotification( 'warning', `You cannot move messages from "${ folderList[ messageFolder.id ].name }" folder` );
			return;
		}

		if( otherFolders.length <= 0 ) {
			displayNotification( 'warning', 'You don\'t have messages folders' );
			return;
		}

		if( selectedPMs.length <= 0 ) {
			return;
		}

		otherFolders.map( ( fid ) => {
			let folder = folderList[ fid ],
				textOp = `${ decode( folder.name ) } ( ${ folder.count } message${ folder.count === 1 ? '' : 's' } )`,
				op = <option key={ `folder_${folder.id}` } value={ folder.id }>{ textOp }</option>;
			folderSelect.push( op );
		} );

		let title = "Move Messages",
			content = <div>
				<p>Where do you want to move { selectedPMs.length > 1 ? 'them' : 'it' }? </p>
				<div className="styled-field folderList">
					<select ref={ (f) => this.selectFolder = f } >
						{ folderSelect }
					</select>
				</div>
			</div>;

		this.props.dispatch( showConfirmModal( title, content, () => this.props.dispatch( movePMs( selectedPMs, this.selectFolder.value ) ) ) );

	};

	// Options showed as icons (HeaderComponent) should not be here, le's avoid duplications
	buildOptions() {
		let isLoggedin = this.props.dispatch( isLoggedIn() ),
			options = [],
			logIn = isLoggedin ? null : <li key="login" onClick={ () => this.login() }>Login</li>,
			refresh = <li key="refresh" onClick={ () => this.refresh() }>Refresh</li>,
			settings = <li key="settings" onClick={ () => this.settings() }>Settings</li>;

		if( this.currentPath && this.currentPath.length > 0 ) {
			switch( this.currentPath[ 1 ] || this.currentPath[ 0 ] ) {
				case '/':
					if( process.env.config.section.home === true ) {
						refresh = false;
						options = [
							<li key="refresh" onClick={ () => this.refreshWidgets() }>Refresh</li>
						];
					} else {
						options = [
							<li key="markasread" onClick={ this.callMarkAsRead }>Mark { this.currentPath[ 2 ] ? `forum ` : `` }as read</li>
						];
					}
					break;

				case 'forums':
					if( isLoggedin ) {
						options = [
							<li key="markasread" onClick={ this.callMarkAsRead }>Mark { this.currentPath[ 2 ] ? `forum ` : `` }as read</li>
						];
						if( this.currentPath[ 2 ] ) {
							let subscribe = this.props.dispatch( isSubscribedForum() ) ?
								<li key="subscribe" onClick={ () => this.subscribeTo( 1 ) }>Unsubscribe</li> :
								<li key="subscribe" onClick={ () => this.subscribeTo( 0 ) }>Subscribe</li>;
							options.push( subscribe );
						}
					}
					break;

				case 'topics':
					let share = <li key="share" onClick={ () => this.shareLink() }>Share this page</li>;
					if( isLoggedin ) {
						options = [];

						let subscribe = this.props.dispatch( isSubscribedThread() ) ?
							<li key="subscribe" onClick={ () => this.subscribeTo( 1 ) }>Unsubscribe</li> :
							<li key="subscribe" onClick={ () => this.subscribeTo( 0 ) }>Subscribe</li>;
						options.push( subscribe );

						let threadDeletePerms = this.props.dispatch( canDeleteThread() );
						if( threadDeletePerms !== null ) {
							let deleteThread = threadDeletePerms ?
								<li key="deleteThread" onClick={ () => this.deleteThread( false ) }>Delete topic</li> :
								<li key="restoreThread" onClick={ () => this.deleteThread( true ) }>Restore topic</li>;
							options.unshift( deleteThread );
						}

						let threadOpenClosePerms = this.props.dispatch( canOpenCloseThread() );
						if( threadOpenClosePerms !== null ) {
							options.unshift( share );
						}

					} else {
						options.unshift( share );
					}

					break;

				case 'following':
				case 'participated':
				case 'latest':
				case 'updated':
					options = [
						<li key="markasread" onClick={ this.callMarkAsRead }>Mark all as read</li>,
					];
					break;

				case 'pms':
					if( typeof this.currentPath[2] !== 'undefined' ) {
						options = [
							<li key="markasread" onClick={ this.callMarkAsRead }>Mark folder as read</li>,
						];
					}
					break;

				case 'pm':
					options = [];
					let messageFolder = this.props.dispatch( currentPMFolder( parseInt( this.currentPath[ 2 ] ) ) ),
						folderList = this.props.dispatch( getPmFolders() ),
						foldersCanMove = Object.keys( folderList ).filter( ( f ) => folderList[ f ].movableitems && parseInt( f ) !== parseInt( messageFolder.id ) );

					if( messageFolder && folderList[ messageFolder.id ].movableitems && foldersCanMove.length ) {
						options = [ <li key="movePM" onClick={ this.moveSelectedPms }>Move Message to folder</li> ];
					}
					break;

				case 'userprofile':
					let banUserOptions = [],
						current_User = this.props.dispatch( currentUser() ),
						selected_user = parseInt( this.currentPath[ 2 ] ),
						selected_user_info = null;

					// ModTools
					if( this.props.userPermissions && this.props.userPermissions.modperms && current_User.id !== selected_user ) {
						if( current_User && selected_user ) {
							selected_user_info = this.props.dispatch( getUserInfo( selected_user ) );
						}
						if( selected_user_info ) {
							if( !selected_user_info.is_banned && this.props.userPermissions.modperms.canbanusers ) {
								banUserOptions = this.props.userPermissions.modperms.banuser_actions.map( ( banAction ) => {
									return <li key={`banUser${ banAction[ 1 ] }`} onClick={ () => this.banUser( selected_user_info, banAction[ 1 ] ) }>{ banAction[ 0 ] }</li>
								} );

							} else if( selected_user_info.is_banned && this.props.userPermissions.modperms.canunbanusers ) {
									banUserOptions = [ <li key="unbanUser" onClick={ () => this.banUser( selected_user_info, 'unban' ) }>Lift ban</li> ];
								}
						}
						if( banUserOptions.length > 0 ) {
							options.unshift( ...banUserOptions );
						}
					}
					break;

				case 'register':
					options = [];
					logIn = null;
					refresh = false;
					break;

				case 'settings':
					options = [
						<li key="goback" onClick={ () => this.goBack() }>Close Settings</li>,
					];
					refresh = false;
					settings = false;
					break;

				default:

			}
			// We'll have refresh everywhere unless we specifically avoid it
			if( refresh ) {
				options.push( refresh );
			}
			// We'll have settings everywhere unless we specifically avoid it
			if( settings ) {
				options.push( settings );
			}
		}

		return (
			<ul>
				{ logIn }
				{ options }
			</ul>
		);
	}

	render() {
		let opened = this.props.ui.headerOverflowOpened ? 'opened' : '',
			options = this.props.ui.headerOverflowOpened ? this.buildOptions() : '';

		return (
			<section>
				<div id='headerOverFlow' className={ 'overflow ' + opened }>
					{ options }
				</div>
			</section>
		)
	}
}

export default connect( headerSelector )( HeaderOverflow );


// WEBPACK FOOTER //
// ./src/components/header/HeaderOverflowComponent.js